import React from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import styles from './styles/drawerContent';
import classnames from 'classnames';

const name = 'DrawerContent';
const useStyles = createUseStyles(styles, 'DrawerContent');

function DrawerContent({ className, children }) {
    const classes = useStyles();
    const rootClassName = classnames(classes.root, className);

    return (
        <div className={rootClassName}>
            <div className={classes.scroll}>{children}</div>
        </div>
    );
}

DrawerContent.propTypes = {};

const component = React.memo(DrawerContent);

component.displayName = name;

export default component;
